/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{resolveVariant as t}from"../../render/utils/resolve-dynamic-variants.js";import{animateTarget as e}from"./visual-element-target.js";import{animateVariant as i}from"./visual-element-variant.js";function r(r,o,n={}){let s;if(r.notify("AnimationStart",o),Array.isArray(o)){const t=o.map((t=>i(r,t,n)));s=Promise.all(t)}else if("string"==typeof o)s=i(r,o,n);else{const i="function"==typeof o?t(r,o,n.custom):o;s=Promise.all(e(r,i,n))}return s.then((()=>r.notify("AnimationComplete",o)))}export{r as animateVisualElement};
//# sourceMappingURL=visual-element.js.map
